(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["anchor-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initNav(nav) {
      if (nav.dataset.anInit === '1') return;
      nav.dataset.anInit = '1';

      var links = Array.prototype.slice.call(nav.querySelectorAll('.anchor-nav__link'));
      var smooth = nav.getAttribute('data-smooth-scroll') === 'true';
      var spy = nav.getAttribute('data-scroll-spy') === 'true';
      var offset = parseInt(nav.getAttribute('data-sticky-offset') || '0', 10) || 0;

      var linkById = {};
      var targets = [];

      links.forEach(function (link) {
        var id = link.getAttribute('data-target');
        if (!id) return;
        var el = document.getElementById(id);
        if (el) {
          linkById[id] = link;
          targets.push(el);
        }
        if (smooth && !reduceMotion) {
          link.addEventListener('click', function (e) {
            var t = document.getElementById(id);
            if (!t) return;
            e.preventDefault();
            var y = t.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            if (history.replaceState) { history.replaceState(null, '', '#' + id); }
          });
        }
      });

      if (spy && targets.length && 'IntersectionObserver' in window) {
        var setActive = function (link) {
          links.forEach(function (l) {
            l.classList.remove('is-active');
            l.removeAttribute('aria-current');
          });
          if (link) {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'true');
          }
        };
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              setActive(linkById[en.target.id]);
            }
          });
        }, { rootMargin: '-' + (offset + 10) + 'px 0px -55% 0px', threshold: 0 });
        targets.forEach(function (t) { obs.observe(t); });
      }
    }

    function run() {
      var navs = document.querySelectorAll('.anchor-nav');
      Array.prototype.forEach.call(navs, initNav);
    }

    if (document.readyState !== 'loading') { run(); }
    else { document.addEventListener('DOMContentLoaded', run); }
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var btns = document.querySelectorAll('.back-to-top');
      for (var i = 0; i < btns.length; i++) {
        var threshold = parseInt(btns[i].getAttribute('data-show-after'), 10);
        if (isNaN(threshold)) { threshold = 400; }
        btns[i].classList.toggle('is-visible', y > threshold);
      }
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }
    }

    function onClick(e) {
      var btn = e.target.closest ? e.target.closest('.back-to-top__btn') : null;
      if (!btn) { return; }
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    function init() {
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('click', onClick);
      update();
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["code-block"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nerdioCodeBlockCopyBound) return;
    window.__nerdioCodeBlockCopyBound = true;

    function flash(label, btn) {
      var original = label.getAttribute('data-original') || label.textContent;
      label.setAttribute('data-original', original);
      label.textContent = 'Copied!';
      btn.setAttribute('data-copied', 'true');
      window.clearTimeout(btn.__cbTimer);
      btn.__cbTimer = window.setTimeout(function () {
        label.textContent = original;
        btn.removeAttribute('data-copied');
      }, 1600);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        try {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.code-block__copy');
      if (!btn) return;
      var surface = btn.closest('.code-block__surface');
      if (!surface) return;
      var src = surface.querySelector('.code-block__source');
      var label = btn.querySelector('.code-block__copy-label') || btn;
      var text = src ? src.value : '';
      copyText(text).then(function () {
        flash(label, btn);
      }).catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-carousel"] && !Shopify.designMode) return;
  try {
    function hydrateDeferredImages(root) {
    const deferred = root.querySelectorAll('img.cat-card__img--deferred[data-src]');
    if (!deferred.length) return;
    if (!('IntersectionObserver' in window)) {
      deferred.forEach(function(img) { swapIn(img); });
      return;
    }
    const io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          swapIn(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { root: root.querySelector('.cat-carousel__viewport'), rootMargin: '0px 600px 0px 600px', threshold: 0.01 });
    deferred.forEach(function(img) { io.observe(img); });
  }

  function swapIn(img) {
    const src = img.getAttribute('data-src');
    const srcset = img.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.classList.remove('cat-card__img--deferred');
  }

  function initCatCarousel(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const track = root.querySelector('[data-track]');
    const cards = Array.from(track.querySelectorAll('.cat-card'));
    if (!cards.length || !track) return;
    hydrateDeferredImages(root);
    const prevBtn = root.querySelector('[data-dir="prev"]');
    const nextBtn = root.querySelector('[data-dir="next"]');
    const paginationHost = root.querySelector('[data-carousel-pagination]');
    let paginationButtons = [];
    let pos = 0;
    let pointerActive = false;
    let isDragging = false;
    let pointerId = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragDX = 0;
    let baseOffset = 0;

    function rightBreath() {
      if (root.classList.contains('cat-carousel--contained')) return 0;
      /* Last card sits INSIDE the page container — 2x container-margin gives a
         visible inset (matches shop-the-feed visually). */
      const cm = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--container-margin')) || 32;
      return cm * 2;
    }

    function maxScroll() {
      const last = cards[cards.length - 1];
      const trackEnd = last.offsetLeft + last.offsetWidth;
      const viewportW = track.parentElement.clientWidth;
      const paddingLeft = parseFloat(getComputedStyle(track.parentElement).paddingLeft) || 0;
      return Math.max(0, paddingLeft + trackEnd - viewportW + rightBreath());
    }

    function maxIndex() {
      /* highest card index whose target offset is still less than maxScroll */
      const max = maxScroll();
      const firstOffset = cards[0].offsetLeft;
      for (let i = 0; i < cards.length; i++) {
        if ((cards[i].offsetLeft - firstOffset) >= max - 1) return i;
      }
      return cards.length - 1;
    }

    function clamp(n) {
      return Math.max(0, Math.min(maxIndex(), n));
    }

    function targetOffset() {
      const target = cards[pos];
      if (!target) return 0;
      const firstOffset = cards[0].offsetLeft;
      const wanted = target.offsetLeft - firstOffset;
      return Math.min(wanted, maxScroll());
    }

    function setTransform(animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(' + (-targetOffset()) + 'px)';
      updateNav();
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = pos <= 0;
      if (nextBtn) nextBtn.disabled = pos >= maxIndex();
      paginationButtons.forEach(function(button, index) {
        const active = index === pos;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function buildPagination() {
      if (!paginationHost) return;
      const pageCount = maxIndex() + 1;
      paginationHost.replaceChildren();
      paginationButtons = [];
      for (let index = 0; index < pageCount; index++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'carousel-pagination__item';
        button.setAttribute('aria-label', 'Go to carousel position ' + (index + 1));
        button.addEventListener('click', function() {
          pos = clamp(index);
          setTransform(true);
        });
        paginationHost.appendChild(button);
        paginationButtons.push(button);
      }
    }

    function go(dir) {
      pos = clamp(pos + dir);
      setTransform(true);
    }

    prevBtn && prevBtn.addEventListener('click', function() { go(-1); });
    nextBtn && nextBtn.addEventListener('click', function() { go(1); });

    /* Drag detection only kicks in once movement exceeds the threshold AND is
       primarily horizontal. Plain taps/clicks never enter drag mode, so anchor
       navigation works without any pointer-events interference. */
    let suppressClick = false;
    const DRAG_THRESHOLD = 6;

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('[data-dir]')) return;
      pointerActive = true;
      isDragging = false;
      pointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragDX = 0;
      baseOffset = cards[pos].offsetLeft;
    }

    function onPointerMove(e) {
      if (!pointerActive) return;
      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;
      if (!isDragging) {
        if (Math.abs(dx) <= DRAG_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          // Vertical scroll wins — abandon this gesture entirely.
          pointerActive = false;
          return;
        }
        isDragging = true;
        track.classList.add('is-dragging');
        track.style.transition = 'none';
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
      dragDX = dx;
      const proposed = baseOffset - dragDX;
      const max = maxScroll();
      let clamped;
      if (proposed < 0) clamped = proposed * 0.35;
      else if (proposed > max) clamped = max + (proposed - max) * 0.35;
      else clamped = proposed;
      track.style.transform = 'translateX(' + (-clamped) + 'px)';
    }

    function onPointerUp() {
      if (!pointerActive) return;
      pointerActive = false;
      if (!isDragging) return; // plain click — let it through
      isDragging = false;
      track.classList.remove('is-dragging');
      track.style.transition = '';
      suppressClick = true;
      const threshold = cards[pos].offsetWidth * 0.15;
      if (dragDX < -threshold) go(1);
      else if (dragDX > threshold) go(-1);
      else setTransform(true);
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    /* dragstart preempts touch + pointer drag */
    track.addEventListener('dragstart', function(e) { e.preventDefault(); });
    /* Swallow only the synthetic click that follows a real swipe */
    track.addEventListener('click', function(e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);

    let resizeRaf;
    window.addEventListener('resize', function() {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function() {
        pos = clamp(pos);
        buildPagination();
        setTransform(false);
      });
    });

    buildPagination();
    setTransform(false);
  }

  function bootCatCarousel() {
    document.querySelectorAll('[data-cat-carousel]').forEach(initCatCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCatCarousel);
  } else {
    bootCatCarousel();
  }
  document.addEventListener('shopify:section:load', bootCatCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown-display"] && !Shopify.designMode) return;
  try {
    function initCountdownDisplay(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const target = new Date(root.dataset.target).getTime();
    if (isNaN(target)) return;
    const d = root.querySelector('[data-days]');
    const h = root.querySelector('[data-hours]');
    const m = root.querySelector('[data-minutes]');
    const s = root.querySelector('[data-seconds]');
    if (!d || !h || !m || !s) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      const diff = Math.max(0, target - Date.now());
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      d.textContent = pad(days);
      h.textContent = pad(hours);
      m.textContent = pad(mins);
      s.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  }

  function bootCountdownDisplay() {
    document.querySelectorAll('[data-countdown-display]').forEach(initCountdownDisplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCountdownDisplay);
  } else {
    bootCountdownDisplay();
  }
  document.addEventListener('shopify:section:load', bootCountdownDisplay);
  document.addEventListener('shopify:block:load', bootCountdownDisplay);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flip-box"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__flipBoxInit) return;
    window.__flipBoxInit = true;

    function toggle(box) {
      var flipped = box.classList.toggle('is-flipped');
      box.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.flip-box__btn')) return;
      var box = e.target.closest('.flip-box--click');
      if (box) toggle(box);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var box = e.target.closest('.flip-box--click');
      if (!box || box !== e.target) return;
      if (e.target.closest('.flip-box__btn')) return;
      e.preventDefault();
      toggle(box);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nerdioGalleryLightbox) return;
    window.__nerdioGalleryLightbox = true;

    var overlay = null;
    var imgEl = null;

    function build() {
      overlay = document.createElement('div');
      overlay.className = 'gallery-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'gallery-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '&times;';

      imgEl = document.createElement('img');
      imgEl.className = 'gallery-lightbox__img';
      imgEl.alt = '';

      overlay.appendChild(closeBtn);
      overlay.appendChild(imgEl);
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target === closeBtn) close();
      });
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    }

    function open(src, alt) {
      if (!overlay) build();
      imgEl.src = src;
      imgEl.alt = alt || '';
      overlay.classList.add('is-open');
      document.documentElement.classList.add('gallery-lightbox-lock');
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('gallery-lightbox-lock');
      document.removeEventListener('keydown', onKey);
    }

    document.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('.gallery-block[data-lightbox="true"] img');
      if (!img) return;
      e.preventDefault();
      open(img.currentSrc || img.src, img.alt);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["heading-fancy"] && !Shopify.designMode) return;
  try {
    (function () {
    /* ===== Shared motion guard + per-root teardown =====
       Rotator intervals and the entrance IntersectionObserver used to outlive
       theme-editor re-renders (no shopify:section:unload cleanup), leaking one
       runner per re-render. Every timer/observer is now tracked per block root
       and killed on unload; the existing shopify:section:load listeners re-init
       the fresh DOM (same pattern as assets/motion-controller.js). */
    function motionOff() {
      return (window.nrdMotionOff)
        ? window.nrdMotionOff()
        : (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ||
          document.documentElement.dataset.motionEnabled === 'false';
    }

    var hfStates = [];
    function createState(root) {
      var state = { root: root, dead: false, timers: [], intervals: [], observers: [] };
      hfStates.push(state);
      return state;
    }
    function stateInterval(state, fn, ms) {
      var id = setInterval(function () { if (!state.dead) fn(); }, ms);
      state.intervals.push(id);
      return id;
    }
    function stateTimeout(state, fn, ms) {
      var id = setTimeout(function () { if (!state.dead) fn(); }, ms);
      state.timers.push(id);
      return id;
    }
    function killState(state) {
      state.dead = true;
      state.intervals.forEach(clearInterval);
      state.timers.forEach(clearTimeout);
      state.observers.forEach(function (io) { io.disconnect(); });
      state.intervals = [];
      state.timers = [];
      state.observers = [];
    }
    document.addEventListener('shopify:section:unload', function (event) {
      hfStates = hfStates.filter(function (state) {
        var gone = !state.root.isConnected || event.target === state.root ||
          (event.target.contains && event.target.contains(state.root));
        if (gone) killState(state);
        return !gone;
      });
    });

    /* ===== Helpers ===== */
    function getLeavesIn(root) {
      // .hf-mark-text included so per-element bg-clip:text painting reaches
      // highlighted words even when no entrance split is active — otherwise
      // they inherit color:transparent from the heading with no own gradient
      // and render invisible, leaving just the underline SVG floating.
      var all = root.querySelectorAll('.hf-word, .hf-char, .hf-rotate, .hf-mark-text');
      return Array.prototype.filter.call(all, function (el) {
        return !el.querySelector('.hf-word, .hf-char, .hf-rotate, .hf-mark-text');
      });
    }

    /* Replicate parent's gradient/image onto each leaf with offset bg-position
       so the slice lines up. Sidesteps the Webkit/Blink bg-clip:text bug where
       inline-block + transformed children render invisible. */
    function applyClipFill(heading, leaves) {
      var pcs = getComputedStyle(heading);
      var clip = pcs.webkitBackgroundClip || pcs.backgroundClip;
      if (clip !== 'text') return;
      var bgImage = pcs.backgroundImage;
      if (!bgImage || bgImage === 'none') return;
      var hRect = heading.getBoundingClientRect();
      leaves.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.backgroundImage = bgImage;
        el.style.backgroundSize = hRect.width + 'px ' + hRect.height + 'px';
        el.style.backgroundPosition = (-(r.left - hRect.left)) + 'px ' + (-(r.top - hRect.top)) + 'px';
        el.style.webkitBackgroundClip = 'text';
        el.style.backgroundClip = 'text';
        el.style.webkitTextFillColor = 'transparent';
        el.style.color = 'transparent';
      });
    }

    function shouldSkipNode(node, root) {
      var p = node.parentNode;
      while (p && p !== root) {
        if (p.classList && (p.classList.contains('hf-mark-svg') || p.classList.contains('hf-rotate'))) return true;
        p = p.parentNode;
      }
      return false;
    }

    /* ===== Splitters ===== */
    function processRotators(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return shouldSkipNode(n, root) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
      });
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var pattern = /\{([^{}]+\|[^{}]+)\}/g;
      var rotators = [];
      nodes.forEach(function (node) {
        var text = node.nodeValue;
        if (!pattern.test(text)) return;
        pattern.lastIndex = 0;
        var frag = document.createDocumentFragment();
        var lastIdx = 0, m;
        while ((m = pattern.exec(text)) !== null) {
          if (m.index > lastIdx) frag.appendChild(document.createTextNode(text.slice(lastIdx, m.index)));
          var words = m[1].split('|').map(function (s) { return s.trim(); }).filter(Boolean);
          if (words.length < 2) {
            frag.appendChild(document.createTextNode(m[0]));
          } else {
            var span = document.createElement('span');
            span.className = 'hf-rotate';
            span.setAttribute('data-words', JSON.stringify(words));
            span.setAttribute('data-i', '0');
            span.textContent = words[0];
            frag.appendChild(span);
            rotators.push(span);
          }
          lastIdx = m.index + m[0].length;
        }
        if (lastIdx < text.length) frag.appendChild(document.createTextNode(text.slice(lastIdx)));
        if (node.parentNode) node.parentNode.replaceChild(frag, node);
      });
      return rotators;
    }

    function splitWords(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return shouldSkipNode(n, root) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
      });
      var textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      var words = [];
      textNodes.forEach(function (node) {
        var text = node.nodeValue;
        if (!text || !text.trim()) return;
        var frag = document.createDocumentFragment();
        var parts = text.split(/(\s+)/);
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            var span = document.createElement('span');
            span.className = 'hf-word';
            span.textContent = part;
            frag.appendChild(span);
            words.push(span);
          }
        });
        if (node.parentNode) node.parentNode.replaceChild(frag, node);
      });
      return words;
    }

    function splitChars(words) {
      var chars = [];
      words.forEach(function (w) {
        var text = w.textContent;
        while (w.firstChild) w.removeChild(w.firstChild);
        for (var i = 0; i < text.length; i++) {
          var c = document.createElement('span');
          c.className = 'hf-char';
          c.textContent = text[i];
          w.appendChild(c);
          if (text[i].trim()) chars.push(c);
        }
      });
      return chars;
    }

    /* Tag each loop target (chars or words) with --i so CSS animation-delay
       can stagger via calc(var(--i) * var(--hf-loop-stagger)). */
    function indexLoopTargets(root, target) {
      var sel = target === 'words' ? '.hf-word' : '.hf-char';
      var nodes = root.querySelectorAll(sel);
      Array.prototype.forEach.call(nodes, function (n, i) {
        n.style.setProperty('--i', i);
      });
    }

    /* ===== Mark draw ===== */
    function drawMarks(root) {
      root.querySelectorAll('.hf-mark').forEach(function (m) {
        m.classList.add('is-drawn');
      });
    }

    function observeOnce(target, cb) {
      if (!('IntersectionObserver' in window)) { cb(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          cb();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      io.observe(target);
    }

    /* ===== Rotators ===== */
    function startRotators(root, rotators, state) {
      if (!rotators.length || !window.gsap) return;
      var d = root.dataset;
      var interval = parseInt(d.rotateInterval, 10) || 3000;
      var effect = d.rotateEffect || 'crossfade';
      var heading = root.querySelector('.hf__heading');

      rotators.forEach(function (r) {
        var words;
        try { words = JSON.parse(r.getAttribute('data-words') || '[]'); } catch (e) { words = []; }
        if (!words.length) return;

        // Pre-measure each variant's natural width so we can smoothly tween min-width on swap.
        var orig = r.textContent;
        var widths = words.map(function (w) {
          r.textContent = w;
          return Math.ceil(r.getBoundingClientRect().width);
        });
        r.textContent = orig;
        r.style.minWidth = widths[0] + 'px';

        function repinBg() {
          // Re-pin EVERY leaf in the heading, not just this rotator. When rotator
          // width changes, surrounding words shift horizontally and their bg-position
          // gets stale, causing the gradient to "wrap" with wrong slices visible.
          if (!heading) return;
          var allLeaves = getLeavesIn(heading);
          if (allLeaves.length) applyClipFill(heading, allLeaves);
        }

        var i = 0;

        // Real char-by-char typewriter: backspace current → type next → hold → repeat.
        // Self-schedules (recursive setTimeout) instead of using the outer interval tick,
        // since the cycle length depends on word length.
        function runTypewriter() {
          var current = words[i];
          var nextI = (i + 1) % words.length;
          var target = words[nextI];
          var ci = current.length;
          var bs = stateInterval(state, function () {
            ci--;
            r.firstChild ? (r.firstChild.nodeValue = current.slice(0, ci)) : (r.textContent = current.slice(0, ci));
            if (ci <= 0) {
              clearInterval(bs);
              window.gsap.to(r, { minWidth: widths[nextI], duration: 0.45, ease: 'power3.inOut', onComplete: repinBg });
              var ti = 0;
              var ty = stateInterval(state, function () {
                ti++;
                r.firstChild ? (r.firstChild.nodeValue = target.slice(0, ti)) : (r.textContent = target.slice(0, ti));
                if (ti >= target.length) {
                  clearInterval(ty);
                  i = nextI;
                  r.setAttribute('data-i', String(i));
                  repinBg();
                  stateTimeout(state, runTypewriter, interval);
                }
              }, 70);
            }
          }, 38);
        }

        if (effect === 'typewriter') {
          // Wrap text content in a text node so we can update without nuking ::after cursor.
          r.classList.add('is-typing');
          // Kick off after entrance settles (caller already delayed start)
          stateTimeout(state, runTypewriter, interval);
          return;
        }

        function tick() {
          var nextI = (i + 1) % words.length;
          var nextW = widths[nextI];
          var swap = function () {
            r.textContent = words[nextI];
            r.setAttribute('data-i', String(nextI));
            repinBg();
          };
          // Tween min-width separately so layout shifts smoothly under the swap.
          // onComplete re-pins all leaves so neighbouring words show the correct
          // gradient slice after horizontal layout shifts.
          window.gsap.to(r, { minWidth: nextW, duration: 0.45, ease: 'power3.inOut', onComplete: repinBg });
          var gsap = window.gsap;
          switch (effect) {
            case 'slide-up':
              gsap.to(r, { y: -10, opacity: 0, duration: 0.22, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.34, ease: 'power3.out', clearProps: 'transform,translate' });
              }});
              break;
            case 'slide-down':
              gsap.to(r, { y: 10, opacity: 0, duration: 0.22, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { y: -14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.34, ease: 'power3.out', clearProps: 'transform,translate' });
              }});
              break;
            case 'scale-pop':
              gsap.to(r, { scale: 0.78, opacity: 0, duration: 0.2, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { scale: 1.12, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.5)', clearProps: 'transform,scale' });
              }});
              break;
            case 'bounce-in':
              gsap.to(r, { y: -8, opacity: 0, duration: 0.18, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, ease: 'bounce.out', clearProps: 'transform,translate' });
              }});
              break;
            case 'rotate-in':
              gsap.to(r, { rotation: -10, opacity: 0, duration: 0.22, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { rotation: 12, opacity: 0 }, { rotation: 0, opacity: 1, duration: 0.45, ease: 'back.out(1.5)', clearProps: 'transform,rotation' });
              }});
              break;
            case 'flip':
              gsap.to(r, { rotationX: 92, opacity: 0, duration: 0.28, ease: 'power2.in', transformPerspective: 600, transformOrigin: '50% 100%', onComplete: function () {
                swap();
                gsap.fromTo(r,
                  { rotationX: -92, opacity: 0, transformPerspective: 600, transformOrigin: '50% 0%' },
                  { rotationX: 0, opacity: 1, duration: 0.42, ease: 'power3.out', clearProps: 'transform,rotationX,perspective' });
              }});
              break;
            case 'blur':
              gsap.to(r, { filter: 'blur(10px)', opacity: 0, duration: 0.26, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { filter: 'blur(10px)', opacity: 0 }, { filter: 'blur(0px)', opacity: 1, duration: 0.42, ease: 'power3.out', clearProps: 'filter,opacity' });
              }});
              break;
            case 'crossfade':
            default:
              gsap.to(r, { opacity: 0, duration: 0.22, ease: 'power2.in', onComplete: function () {
                swap();
                gsap.fromTo(r, { opacity: 0 }, { opacity: 1, duration: 0.34, ease: 'power3.out', clearProps: 'opacity' });
              }});
          }
          i = nextI;
        }
        stateInterval(state, tick, interval);
      });
    }

    /* ===== Init flow ===== */
    function init(root) {
      if (root.dataset.hfInit) return;
      root.dataset.hfInit = '1';
      var heading = root.querySelector('.hf__heading');
      if (!heading) return;
      var state = createState(root);

      var effect = root.dataset.fancyEffect;
      var isClone = !!root.closest('[aria-hidden="true"]');
      var loopAnim = root.dataset.loopAnim || 'none';
      var splitTarget = root.dataset.needsSplit || ''; // 'chars' | 'words' | ''

      // Process rotators FIRST so their content isn't word-split.
      var rotators = processRotators(heading);
      var words = [];
      var chars = [];

      // Split if entrance OR loop needs it. Loop with target='words' only
      // needs word split; with target='chars' (default) needs char split.
      var needsWords = effect === 'word-fade-up' || splitTarget === 'words' || splitTarget === 'chars';
      var needsChars = effect === 'char-fade' || splitTarget === 'chars';
      if (needsWords) {
        words = splitWords(heading);
        if (needsChars) chars = splitChars(words);
      }
      if (loopAnim !== 'none' && splitTarget) {
        indexLoopTargets(heading, splitTarget);
      }

      // Apply gradient bg per leaf so transformed children don't break clip-text
      var leaves = getLeavesIn(heading);
      if (leaves.length) applyClipFill(heading, leaves);

      // Prepare entrance animation but don't fire yet — wait for viewport intersection
      // so animations don't burn off invisibly when blocks are below the fold.
      var animTargets = null;
      var fromVars = null;
      var entranceTotal = 0;
      if (!isClone && !motionOff() && window.gsap) {
        if (effect === 'char-fade') animTargets = chars;
        else if (effect === 'word-fade-up') animTargets = words.concat(rotators);
        if (animTargets && animTargets.length) {
          var d = root.dataset;
          var dur = parseInt(d.animDuration, 10) || 700;
          var del = parseInt(d.animDelay, 10) || 0;
          var stg = parseInt(d.animStagger, 10) || 30;
          fromVars = (effect === 'char-fade')
            ? { y: 18, opacity: 0, scale: 0.88 }
            : { y: 28, opacity: 0 };
          // Pre-hide the targets immediately so IO can fire whenever without a flash.
          window.gsap.set(animTargets, fromVars);
          fromVars = {
            y: 0, opacity: 1, scale: 1,
            duration: dur / 1000,
            delay: del / 1000,
            ease: d.animEase || 'power2.out',
            stagger: stg / 1000,
            clearProps: 'transform,translate,scale,rotate'
          };
          entranceTotal = dur + del + animTargets.length * stg;
        }
      }

      function fireSequence() {
        if (animTargets && animTargets.length && fromVars) {
          window.gsap.to(animTargets, fromVars);
        }
        var markDrawDelay = entranceTotal > 0 ? entranceTotal + 150 : 0;
        if (root.querySelectorAll('.hf-mark').length) {
          stateTimeout(state, function () { drawMarks(root); }, markDrawDelay);
        }
        if (rotators.length && root.dataset.rotateEnabled === 'true') {
          var startDelay = entranceTotal > 0 ? entranceTotal + 700 : 1200;
          stateTimeout(state, function () { startRotators(root, rotators, state); }, startDelay);
        }
      }

      if (isClone || motionOff()) {
        // Clones (slideshow infinite-loop dupes) + motion-off: no entrance,
        // no rotation — final state immediately, marks drawn.
        drawMarks(root);
        return;
      }

      // Trigger when block scrolls into view; if already in view at init, fire now.
      var rect = root.getBoundingClientRect();
      var inView = rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0;
      if (inView) {
        fireSequence();
      } else if ('IntersectionObserver' in window) {
        var entranceIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            entranceIO.unobserve(e.target);
            fireSequence();
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
        state.observers.push(entranceIO);
        entranceIO.observe(root);
      } else {
        fireSequence();
      }
    }

    function bootGsap() {
      document.querySelectorAll('.hf[data-needs-gsap]:not([data-hf-init])').forEach(init);
    }
    function bootCss() {
      document.querySelectorAll('.hf:not([data-needs-gsap]):not([data-hf-init])').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootCss);
    } else {
      bootCss();
    }
    if (window.gsap) {
      bootGsap();
    } else {
      window.addEventListener('gsap:ready', bootGsap);
    }
    document.addEventListener('shopify:section:load', function () { bootCss(); bootGsap(); });
    document.addEventListener('shopify:block:select', function () { bootCss(); bootGsap(); });

    /* Resize: recompute per-leaf bg-position on width change */
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        lastWidth = window.innerWidth;
        document.querySelectorAll('.hf[data-hf-init]').forEach(function (root) {
          var heading = root.querySelector('.hf__heading');
          if (!heading) return;
          var leaves = getLeavesIn(heading);
          if (leaves.length) applyClipFill(heading, leaves);
        });
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["heading"] && !Shopify.designMode) return;
  try {
    (function () {
    function motionOff() {
      return (window.nrdMotionOff)
        ? window.nrdMotionOff()
        : (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ||
          document.documentElement.dataset.motionEnabled === 'false';
    }
    function drawMarks(root) {
      root.querySelectorAll('.hf-mark').forEach(function (m) { m.classList.add('is-drawn'); });
    }
    function init(root) {
      if (root.dataset.hdMarkInit) return;
      var marks = root.querySelectorAll('.hf-mark');
      if (!marks.length) return;
      root.dataset.hdMarkInit = '1';
      // Motion off: marks render drawn immediately, no scroll-in draw.
      if (motionOff() || !('IntersectionObserver' in window)) { drawMarks(root); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          drawMarks(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      io.observe(root);
    }
    function boot() {
      document.querySelectorAll('.heading-block:not([data-hd-mark-init])').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    function heroEditorBlockId(element) {
    if (!element) return '';
    const raw = element.getAttribute('data-shopify-editor-block');
    if (!raw) return '';
    try { return JSON.parse(raw).id || ''; } catch (_) { return ''; }
  }

  function heroSlideForEditorEvent(event, root) {
    const target = event && event.target;
    if (!target || !root) return null;
    const closest = target.closest && target.closest('[data-hero-slide]');
    if (closest && root.contains(closest)) return closest;
    const child = target.querySelector && target.querySelector('[data-hero-slide]');
    if (child && root.contains(child)) return child;

    const selectedId = event.detail && event.detail.blockId;
    if (!selectedId) return null;
    return Array.from(root.querySelectorAll('[data-hero-slide]:not([data-clone])')).find(function(slide) {
      if (heroEditorBlockId(slide) === selectedId) return true;
      return Array.from(slide.querySelectorAll('[data-shopify-editor-block]')).some(function(el) {
        return heroEditorBlockId(el) === selectedId;
      });
    }) || null;
  }

  function initHeroSlideshow(root) {
    if (root.dataset.bound) return;
    const track = root.querySelector('[data-track]');
    if (!track) return;
    const realSlides = Array.from(track.querySelectorAll('[data-hero-slide]:not([data-clone])'));
    const N = realSlides.length;
    root.classList.toggle('hero-slideshow--single', N === 1);
    root.querySelectorAll('[data-pagination], [data-pagination-vnav], [data-hero-controls]').forEach(function(p) { p.hidden = N < 2; });
    if (N === 1) {
      realSlides[0].classList.add('is-active');
      root.dataset.bound = '1';
      return;
    }
    if (N < 2) return;
    root.dataset.bound = '1';
    const aborter = new AbortController();
    const signal = aborter.signal;
    const editorState = window.NerdioHeroEditorState = window.NerdioHeroEditorState || {};
    const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    /* fxMode = a non-sliding transition (fade/zoom/rotate/flip): slides stack
       and crossfade on .is-active, bypassing the horizontal track + clones. */
    const fxMode = (root.dataset.fx || 'slide') !== 'slide';

    let i = 0;
    const rememberedSlideId = editorState[root.id];
    if (rememberedSlideId) {
      const rememberedIndex = realSlides.findIndex(function(slide) {
        return heroEditorBlockId(slide) === rememberedSlideId;
      });
      if (rememberedIndex >= 0) i = rememberedIndex;
    }
    realSlides[i].classList.add('is-active');

    /* Infinite loop: clone last at start and first at end. Clones are
       hidden from assistive tech, and any cloned H1 is demoted to a
       <div role="heading" aria-level="2"> so the page only ever has
       one real H1 (the original first slide). */
    if (!fxMode) {
      const firstClone = realSlides[0].cloneNode(true);
      const lastClone = realSlides[N - 1].cloneNode(true);
      window.NerdioClone?.uniqueIds(firstClone, root.id + '-first');
      window.NerdioClone?.uniqueIds(lastClone, root.id + '-last');
      firstClone.dataset.clone = 'first';
      lastClone.dataset.clone = 'last';
      [firstClone, lastClone].forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('inert', ''); /* clones keep focusable buttons otherwise (axe aria-hidden-focus) */
        c.querySelectorAll('h1').forEach(function (h) {
          const sub = document.createElement('div');
          sub.setAttribute('role', 'heading');
          sub.setAttribute('aria-level', '2');
          sub.className = h.className;
          sub.innerHTML = h.innerHTML;
          h.replaceWith(sub);
        });
      });
      track.appendChild(firstClone);
      track.insertBefore(lastClone, track.firstChild);
    }

    const slides = fxMode ? realSlides : Array.from(track.querySelectorAll('[data-hero-slide]'));
    const prevBtns = root.querySelectorAll('[data-dir="prev"]');
    const nextBtns = root.querySelectorAll('[data-dir="next"]');
    const counters = root.querySelectorAll('[data-current]');
    const totals = root.querySelectorAll('[data-total]');
    totals.forEach(function(t) { t.textContent = ('0' + N).slice(-2); });

    /* Dots-mode pagination — generate one button per real slide, jump on click. */
    const dotsHost = root.querySelector('[data-dots]');
    let dots = [];
    if (dotsHost) {
      dotsHost.innerHTML = '';
      for (let n = 0; n < N; n++) {
        const d = document.createElement('button');
        d.className = 'hero-slideshow__dot';
        d.type = 'button';
        d.setAttribute('aria-label', 'Go to slide ' + (n + 1));
        d.addEventListener('click', function() {
          /* Compute shortest path to target index in the wrapped slides[] space. */
          const delta = n - i;
          if (delta !== 0) go(delta);
          startTimer();
        }, { signal: signal });
        dotsHost.appendChild(d);
        dots.push(d);
      }
    }

    /* Rich nav (tabs / vertical index) — number + title per real slide. */
    const richHost = root.querySelector('[data-richnav]');
    const vnavNum = root.querySelector('[data-vnav-num]');
    let navItems = [];
    if (richHost) {
      richHost.innerHTML = '';
      for (let n = 0; n < N; n++) {
        const titleEl = realSlides[n].querySelector('.heading-block, [role="heading"], h1, h2, h3');
        const label = titleEl ? titleEl.textContent.trim() : ('Slide ' + (n + 1));
        const b = document.createElement('button');
        b.className = 'hero-slideshow__navitem';
        b.type = 'button';
        const numSpan = document.createElement('span');
        numSpan.className = 'hero-slideshow__navnum';
        numSpan.textContent = ('0' + (n + 1)).slice(-2);
        const labelSpan = document.createElement('span');
        labelSpan.className = 'hero-slideshow__navlabel';
        labelSpan.textContent = label;
        b.appendChild(numSpan);
        b.appendChild(labelSpan);
        b.addEventListener('click', function() {
          const delta = n - i;
          if (delta !== 0) go(delta);
          startTimer();
        }, { signal: signal });
        richHost.appendChild(b);
        navItems.push(b);
      }
    }

    let pos = fxMode ? i : i + 1;
    const delay = (parseInt(root.dataset.speed, 10) || 9) * 1000;
    const autoplay = root.dataset.autoplay !== 'false';
    let timer = null;
    let isHover = false;
    let isDragging = false;
    let isTransitioning = false;

    /* Progress-bar pagination — fill scaleX synced to the autoplay interval. */
    const progressFill = root.querySelector('[data-progress-fill]');
    root.style.setProperty('--hs-delay', (delay / 1000) + 's');
    if (progressFill && !autoplay) progressFill.style.animation = 'none';
    function restartProgress() {
      if (!progressFill || !autoplay) return;
      progressFill.style.animation = 'none';
      void progressFill.offsetWidth;
      progressFill.style.animation = '';
      progressFill.style.animationPlayState = 'running';
    }

    function getEdgeInset() {
      const styles = getComputedStyle(root);
      const peek = parseFloat(styles.getPropertyValue('--peek')) || 0;
      const edgeGap = parseFloat(styles.getPropertyValue('--edge-gap')) || 0;
      return peek + edgeGap;
    }

    function setTransform(animate) {
      if (fxMode) return;
      const target = slides[pos];
      const offset = target.offsetLeft;
      const edgeInset = getEdgeInset();
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(' + (-offset + edgeInset) + 'px)';
    }

    function syncMarkers() {
      if (fxMode) {
        realSlides.forEach(function(s, n) { s.classList.toggle('is-active', n === i); });
      } else {
        slides.forEach(function(s, n) { s.classList.toggle('is-active', n === pos); });
      }
      counters.forEach(function(c) { c.textContent = ('0' + (i + 1)).slice(-2); });
      if (dots.length) {
        dots.forEach(function(d, n) { d.classList.toggle('is-active', n === i); });
      }
      if (navItems.length) {
        navItems.forEach(function(b, n) { b.classList.toggle('is-active', n === i); });
      }
      if (vnavNum) vnavNum.textContent = ('0' + (i + 1)).slice(-2);
      restartProgress();
    }

    function go(direction) {
      if (fxMode) {
        i = (i + direction + N) % N;
        syncMarkers();
        return;
      }
      if (isTransitioning) return;
      isTransitioning = true;
      pos += direction;
      i = (i + direction + N) % N;
      setTransform(true);
      syncMarkers();
    }

    function selectSlide(slide) {
      const nextIndex = typeof slide === 'number' ? slide : realSlides.indexOf(slide);
      if (nextIndex < 0 || nextIndex >= N) return;
      i = nextIndex;
      pos = fxMode ? nextIndex : nextIndex + 1;
      isTransitioning = false;
      stopTimer();
      setTransform(false);
      syncMarkers();
    }

    function onTransitionEnd(e) {
      if (fxMode) return;
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (pos === 0) {
        pos = N;
        setTransform(false);
        syncMarkers();
      } else if (pos === N + 1) {
        pos = 1;
        setTransform(false);
        syncMarkers();
      }
      isTransitioning = false;
    }

    track.addEventListener('transitionend', onTransitionEnd, { signal: signal });

    function startTimer() {
      if (!autoplay || designMode || isHover || isDragging) return;
      clearInterval(timer);
      timer = setInterval(function() { go(1); }, delay);
      restartProgress();
    }
    function stopTimer() { clearInterval(timer); timer = null; }

    prevBtns.forEach(function(b) { b.addEventListener('click', function() { go(-1); startTimer(); }, { signal: signal }); });
    nextBtns.forEach(function(b) { b.addEventListener('click', function() { go(1); startTimer(); }, { signal: signal }); });

    root.addEventListener('mouseenter', function() { isHover = true; stopTimer(); if (progressFill) progressFill.style.animationPlayState = 'paused'; }, { signal: signal });
    root.addEventListener('mouseleave', function() { isHover = false; startTimer(); }, { signal: signal });

    let dragStartX = 0;
    let dragDX = 0;
    let baseOffset = 0;

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a')) return;
      isDragging = true;
      stopTimer();
      dragStartX = e.clientX;
      dragDX = 0;
      if (!fxMode) {
        baseOffset = slides[pos].offsetLeft - getEdgeInset();
        track.style.transition = 'none';
      }
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
    }
    function onPointerMove(e) {
      if (!isDragging) return;
      dragDX = e.clientX - dragStartX;
      if (fxMode) return;
      track.style.transform = 'translateX(' + (-baseOffset + dragDX) + 'px)';
    }
    function onPointerUp() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';
      const threshold = slides[pos].offsetWidth * 0.15;
      if (dragDX < -threshold) { go(1); }
      else if (dragDX > threshold) { go(-1); }
      else { setTransform(true); }
      startTimer();
    }
    track.addEventListener('pointerdown', onPointerDown, { signal: signal });
    track.addEventListener('pointermove', onPointerMove, { signal: signal });
    track.addEventListener('pointerup', onPointerUp, { signal: signal });
    track.addEventListener('pointercancel', onPointerUp, { signal: signal });
    track.addEventListener('pointerleave', onPointerUp, { signal: signal });
    track.addEventListener('dragstart', function(e) { e.preventDefault(); }, { signal: signal });

    let resizeRaf;
    window.addEventListener('resize', function() {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function() { setTransform(false); });
    }, { signal: signal });

    let isOnscreen = true;
    let observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          isOnscreen = e.isIntersecting;
          if (isOnscreen && document.visibilityState === 'visible') startTimer();
          else stopTimer();
        });
      }, { threshold: 0 });
      observer.observe(root);
    }

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible' && isOnscreen) startTimer();
      else stopTimer();
    }, { signal: signal });

    root._heroSlideshowController = {
      selectSlide: selectSlide,
      destroy: function() {
        stopTimer();
        cancelAnimationFrame(resizeRaf);
        if (observer) observer.disconnect();
        aborter.abort();
      }
    };

    setTransform(false);
    syncMarkers();
    startTimer();
  }

  function teardownHeroSlideshow(root) {
    if (!root.dataset.bound) return;
    if (root._heroSlideshowController) {
      root._heroSlideshowController.destroy();
      delete root._heroSlideshowController;
    }
    const track = root.querySelector('[data-track]');
    if (track) {
      track.querySelectorAll('[data-clone]').forEach(function(c) { c.remove(); });
      track.style.transform = '';
      track.style.transition = '';
    }
    delete root.dataset.bound;
  }

  function bootHeroSlideshow() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  function rebootHeroSlideshow(e) {
    const root = e && e.target && e.target.closest && e.target.closest('[data-hero-slideshow]');
    if (root) { teardownHeroSlideshow(root); initHeroSlideshow(root); }
    else {
      document.querySelectorAll('[data-hero-slideshow]').forEach(function(r) {
        teardownHeroSlideshow(r);
        initHeroSlideshow(r);
      });
    }
  }

  function selectHeroEditorSlide(e) {
    const target = e && e.target;
    let root = target && target.closest && target.closest('[data-hero-slideshow]');
    if (!root && target && target.querySelector) root = target.querySelector('[data-hero-slideshow]');
    if (!root) return;
    if (!root.dataset.bound) initHeroSlideshow(root);
    const slide = heroSlideForEditorEvent(e, root);
    if (!slide || slide.dataset.clone) return;
    const slideId = heroEditorBlockId(slide);
    if (slideId) {
      const editorState = window.NerdioHeroEditorState = window.NerdioHeroEditorState || {};
      editorState[root.id] = slideId;
    }
    if (root._heroSlideshowController) root._heroSlideshowController.selectSlide(slide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHeroSlideshow);
  } else {
    bootHeroSlideshow();
  }
  document.addEventListener('shopify:section:load', bootHeroSlideshow);
  document.addEventListener('shopify:block:load', rebootHeroSlideshow);
  document.addEventListener('shopify:block:select', selectHeroEditorSlide);
  document.addEventListener('shopify:section:unload', function(e) {
    const root = e.target && e.target.querySelector && e.target.querySelector('[data-hero-slideshow]');
    if (root) teardownHeroSlideshow(root);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-marquee"] && !Shopify.designMode) return;
  try {
    function bootImageMarquee(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    var track = root.querySelector('.image-marquee-block__track');
    var master = root.querySelector('.image-marquee-block__group--master');
    if (!track || !master) return;
    for (var i = 0; i < 3; i++) {
      var clone = master.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      window.NerdioClone?.uniqueIds(clone, root.id + '-' + i);
      track.appendChild(clone);
    }
  }
  function bootAllImageMarquees() {
    document.querySelectorAll('[data-image-marquee]').forEach(bootImageMarquee);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllImageMarquees);
  } else {
    bootAllImageMarquees();
  }
  document.addEventListener('shopify:section:load', bootAllImageMarquees);
  document.addEventListener('shopify:block:select', bootAllImageMarquees);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["logo-strip"] && !Shopify.designMode) return;
  try {
    function bootLogoStrip(root) {
    if (root.dataset.bound) return;
    if (root.getAttribute('data-scroll') !== 'marquee') return;
    root.dataset.bound = '1';
    var track = root.querySelector('.logo-strip-block__track');
    var master = root.querySelector('.logo-strip-block__group--master');
    if (!track || !master) return;
    for (var i = 0; i < 3; i++) {
      var clone = master.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      window.NerdioClone?.uniqueIds(clone, root.id + '-' + i);
      track.appendChild(clone);
    }
  }
  function bootAllLogoStrips() {
    document.querySelectorAll('[data-logo-strip]').forEach(bootLogoStrip);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllLogoStrips);
  } else {
    bootAllLogoStrips();
  }
  document.addEventListener('shopify:section:load', bootAllLogoStrips);
  document.addEventListener('shopify:block:select', bootAllLogoStrips);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["map-embed"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.meInit) return;
    root.dataset.meInit = '1';

    var trigger = root.querySelector('.map-embed__trigger');
    var frame = root.querySelector('.map-embed__frame');
    if (!frame || !trigger) return;

    function loadMap() {
      if (root.dataset.meLoaded || !root.dataset.embedSrc) return;
      root.dataset.meLoaded = '1';
      var iframe = document.createElement('iframe');
      iframe.src = root.dataset.embedSrc;
      iframe.title = root.dataset.mapTitle || 'Map';
      iframe.className = 'map-embed__iframe';
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('allowfullscreen', '');
      frame.appendChild(iframe);
      trigger.style.display = 'none';
      root.classList.add('map-embed--loaded');
    }

    trigger.addEventListener('click', loadMap);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.map-embed');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-addons-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-addons')) {
    customElements.define('product-addons', class ProductAddons extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._handleClick = this.handleClick.bind(this);
        this._handleChange = this.handleChange.bind(this);
        this._handleSubmit = this.handleSubmit.bind(this);
        this._syncSingleAddons = this.syncSingleAddons.bind(this);
        this.addEventListener('click', this._handleClick);
        this.addEventListener('change', this._handleChange);
        this.addEventListener('submit', this._handleSubmit);
        document.addEventListener('cart:updated', this._syncSingleAddons);
        document.addEventListener('cart:item-added', this._syncSingleAddons);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
        this.removeEventListener('change', this._handleChange);
        this.removeEventListener('submit', this._handleSubmit);
        document.removeEventListener('cart:updated', this._syncSingleAddons);
        document.removeEventListener('cart:item-added', this._syncSingleAddons);
        this._connected = false;
      }

      variantValue(form) {
        const radio = form.querySelector('input[data-addon-variant-radio]:checked');
        if (radio) return radio.value;
        const el = form.querySelector('[data-addon-variant]');
        return el ? el.value : '';
      }

      syncSingleAddons(event) {
        const cart = event.detail?.cart;
        if (!cart?.items) return;
        const productIds = new Set(cart.items.map((item) => String(item.product_id)));
        this.querySelectorAll('[data-single-per-order="true"]').forEach((row) => {
          row.hidden = productIds.has(String(row.dataset.addonProductId || ''));
        });
      }

      handleClick(event) {
        const stepButton = event.target.closest('[data-addon-step]');
        if (!stepButton || !this.contains(stepButton)) return;
        const input = stepButton.closest('[data-addon-quantity]')?.querySelector('[data-addon-quantity-input]');
        if (!input) return;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(stepButton.dataset.addonStep, 10));
        input.value = String(next);
      }

      handleChange(event) {
        const picker = event.target.closest('select[data-addon-variant], input[data-addon-variant-radio]');
        if (!picker || !this.contains(picker)) return;
        const form = picker.closest('[data-addon-form]');
        const price = form?.querySelector('[data-addon-price]');
        const source = picker.tagName === 'SELECT' ? picker.selectedOptions[0] : picker;
        if (price && source?.dataset.price) price.textContent = source.dataset.price;
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-addon-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();

        const quantityInput = form.querySelector('[data-addon-quantity-input]');
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-addon-status]');
        const row = form.closest('[data-addon-product-id]');
        const productId = row?.dataset.addonProductId || '';
        const singlePerOrder = row?.dataset.singlePerOrder === 'true';
        const variantId = parseInt(this.variantValue(form), 10);
        const quantity = singlePerOrder ? 1 : Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
        if (!variantId || !button || button.disabled) return;

        if (singlePerOrder && document.querySelector(`[data-cart-line][data-product-id="${productId}"]`)) {
          if (row) row.hidden = true;
          return;
        }

        form.classList.add('is-loading');
        button.disabled = true;
        button.textContent = button.dataset.labelLoading || 'Adding…';
        if (status) status.textContent = '';
        try {
          if (!window.cartStore) throw new Error('Cart is unavailable.');
          const item = { id: variantId, quantity };
          if (singlePerOrder) item.properties = { _single_order_addon: '1' };
          await window.cartStore.add({ items: [item], openDrawer: true });
          button.textContent = button.dataset.labelAdded || 'Added';
          if (status) status.textContent = 'Added to cart.';
          if (quantityInput && quantityInput.type !== 'hidden') quantityInput.value = '1';
          if (singlePerOrder && row) row.hidden = true;
          window.setTimeout(() => {
            button.textContent = button.dataset.labelDefault || 'Add';
            button.disabled = false;
          }, 1400);
        } catch (error) {
          button.textContent = button.dataset.labelError || 'Retry';
          if (status) status.textContent = error instanceof Error ? error.message : 'Could not add this item.';
          window.setTimeout(() => {
            button.textContent = button.dataset.labelDefault || 'Add';
            button.disabled = false;
          }, 1800);
        } finally {
          form.classList.remove('is-loading');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-sticky-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window._pdpStickyBound) return;
    window._pdpStickyBound = true;

    function boot() {
      const bar = document.querySelector('[data-pdp-sticky]');
      if (!bar) return;
      const primaryBtn = document.querySelector('.prd__form .prd__add[name="add"], .prd__form button[name="add"]:not([data-pdp-sticky-btn])');
      if (!primaryBtn) return;

      // Re-parent to <body> on first boot so position:fixed isn't scoped
      // by an ancestor that has `transform` set (scroll-reveal animations
      // on .prd__info create a containing block for fixed descendants).
      // The bar's submit button keeps working via a click-proxy to the
      // primary CTA, which still lives inside the product form.
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      const proxyBtn = bar.querySelector('[data-pdp-sticky-btn]');
      if (proxyBtn) {
        proxyBtn.type = 'button';
        proxyBtn.removeAttribute('name');
        proxyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (primaryBtn.disabled) return;
          primaryBtn.click();
        });
      }

      const titleEl = document.querySelector('.prd__title');
      const priceEl = document.querySelector('.prd__price-current');
      const sTitle = bar.querySelector('[data-pdp-sticky-title]');
      const sPrice = bar.querySelector('[data-pdp-sticky-price]');
      const sBtn = bar.querySelector('[data-pdp-sticky-btn]');
      const sBtnLabel = sBtn ? (sBtn.querySelector('.prd__sticky-cta__btn-label') || sBtn) : null;

      // Mirror live PDP title / price into the bar.
      const sync = () => {
        if (titleEl && sTitle) sTitle.textContent = titleEl.textContent.trim();
        if (priceEl && sPrice) sPrice.textContent = priceEl.textContent.trim();
        if (sBtn && primaryBtn) {
          const wasDisabled = sBtn.disabled;
          sBtn.disabled = primaryBtn.disabled;
          if (wasDisabled !== primaryBtn.disabled) {
            sBtnLabel.textContent = primaryBtn.disabled
              ? (sBtn.dataset.labelSoldOut || 'Sold out')
              : (sBtn.dataset.labelAvailable || sBtnLabel.textContent.trim());
          }
        }
      };
      sync();

      // Watch for variant-picker DOM updates (price + disabled state).
      const mo = new MutationObserver(sync);
      if (titleEl) mo.observe(titleEl, { childList: true, characterData: true, subtree: true });
      if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
      if (primaryBtn) mo.observe(primaryBtn, { attributes: true, attributeFilter: ['disabled'] });

      // Reveal bar when the primary CTA scrolls out of view (mobile only).
      bar.removeAttribute('hidden');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Show when the primary button leaves the viewport, hide when it returns.
          bar.classList.toggle('is-shown', !entry.isIntersecting && window.innerWidth < 901);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(primaryBtn);

      // On viewport resize past the breakpoint, hide explicitly.
      let lastNarrow = window.innerWidth < 901;
      window.addEventListener('resize', () => {
        const narrow = window.innerWidth < 901;
        if (narrow !== lastNarrow) {
          lastNarrow = narrow;
          if (!narrow) bar.classList.remove('is-shown');
        }
      }, { passive: true });
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-bundle"] && !Shopify.designMode) return;
  try {
    function initBundle(root) {
    const rootEl = root.querySelector('.bundle') || root;
    if (rootEl.dataset.bound) return;
    rootEl.dataset.bound = '1';

    const products = rootEl.querySelectorAll('.bundle__product');
    const list = rootEl.querySelector('[data-list]');
    const bar = rootEl.querySelector('[data-bar]');
    const totalEl = rootEl.querySelector('[data-total]');
    const btn = rootEl.querySelector('[data-checkout]');
    const btnLabel = rootEl.querySelector('[data-button-label]');
    const errEl = rootEl.querySelector('[data-err]');

    const MIN = parseInt(rootEl.dataset.minItems, 10) || 1;
    const TAG = (rootEl.dataset.bundleTag || '').trim();
    const STORAGE_KEY = rootEl.dataset.storageKey || 'zenxeon-bundle';
    const READY_LABEL = rootEl.dataset.readyLabel || 'Add bundle to cart';
    const SELECT_LABEL = rootEl.dataset.selectLabel || 'Select products';
    const ADDING_LABEL = rootEl.dataset.addingLabel || 'Adding...';
    const SLOT_LABEL = rootEl.dataset.slotLabel || 'Product';

    /* Center-setup mode: the required core gets a quantity; device picks are
       mutually exclusive; device/mdm/warranty quantities mirror the core
       quantity; install is fixed at one per order sitewide. Warranty is
       device-gated: it auto-adds (still removable) with a warranty-eligible
       device (product type Tablet) and locks when no eligible device is
       picked — Elo touchscreens carry their own manufacturer warranty. */
    const CENTER = rootEl.dataset.centerSetup === 'true';
    let coreQty = 1;
    const SYNC_ROLES = { core: true, device: true, mdm: true, warranty: true };

    function itemFromCard(card) {
      return {
        pid: card.dataset.pid,
        variantId: card.dataset.variantId,
        price: parseInt(card.dataset.price, 10) || 0,
        title: card.dataset.title,
        role: card.dataset.role || 'accessory',
        family: card.dataset.family || '',
        warrantyEligible: card.dataset.warrantyEligible === 'true',
        quantity: 1
      };
    }

    const requiredItems = [];
    products.forEach(function(card) {
      if (card.dataset.required !== 'true') return;
      const item = itemFromCard(card);
      item.role = card.dataset.role || 'core';
      item.required = true;
      requiredItems.push(item);
    });
    let added = requiredItems.slice();

    function warrantyAllowed() {
      if (!CENTER) return true;
      const device = added.find(function(a) { return a.role === 'device'; });
      return !!(device && device.warrantyEligible);
    }

    /* Warranty follows the picked device: auto-add every warranty card when an
       eligible device lands, drop them all when coverage is no longer allowed. */
    function syncWarrantyToDevice(autoAdd) {
      if (!CENTER) return;
      if (warrantyAllowed()) {
        if (!autoAdd) return;
        products.forEach(function(card) {
          if (card.dataset.role !== 'warranty') return;
          if (card.dataset.available === 'false') return;
          if (added.some(function(a) { return a.pid === card.dataset.pid; })) return;
          const item = itemFromCard(card);
          added.push(item);
        });
      } else {
        added = added.filter(function(a) { return a.required || a.role !== 'warranty'; });
      }
    }

    function itemQty(item) {
      if (!CENTER) return 1;
      if (item.role === 'install') return 1;
      if (SYNC_ROLES[item.role]) return coreQty;
      return item.quantity || 1;
    }

    function syncQuantities() {
      added.forEach(function(item) { item.quantity = itemQty(item); });
    }

    function setButtonLabel(value) {
      if (btnLabel) btnLabel.textContent = value;
      else btn.textContent = value;
    }

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function bundleInstanceId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'bundle-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function saveState() {
      try {
        const optionalItems = added.filter(function(item) { return !item.required; });
        if (optionalItems.length === 0) localStorage.removeItem(STORAGE_KEY);
        else localStorage.setItem(STORAGE_KEY, JSON.stringify(optionalItems));
      } catch (e) { /* storage unavailable */ }
    }

    function loadState() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }

    function clearState() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }

    function resetBuilder() {
      added = requiredItems.slice();
      clearState();
      render();
    }

    function findCard(pid) {
      for (let i = 0; i < products.length; i++) {
        if (products[i].dataset.pid === pid) return products[i];
      }
      return null;
    }

    /* Device-management swap: when the set carries both a generic MDM card and
       an EloView card (data-family generic|elo on role=mdm), only the family
       matching the picked device is visible. No device picked → generic. If
       the hidden family was already in the bundle, the visible one takes its
       place so the shopper keeps their management line. Sets with a single
       MDM family (Elo packages, iPad/Samsung-only kiosks) are untouched. */
    const mdmCards = Array.prototype.filter.call(products, function(p) { return p.dataset.role === 'mdm'; });
    const mdmFamilies = mdmCards.reduce(function(set, p) {
      if (p.dataset.family && set.indexOf(p.dataset.family) < 0) set.push(p.dataset.family);
      return set;
    }, []);
    const MDM_SWAP = CENTER && mdmFamilies.length > 1;

    function syncMdmToDevice() {
      if (!MDM_SWAP) return;
      const device = added.find(function(a) { return a.role === 'device'; });
      const target = (device && device.family) || 'generic';
      let changed = false;
      let wasAdded = false;
      mdmCards.forEach(function(card) {
        const match = card.dataset.family === target;
        card.hidden = !match;
        if (match) return;
        const idx = added.findIndex(function(a) { return a.pid === card.dataset.pid; });
        if (idx >= 0) { added.splice(idx, 1); wasAdded = true; changed = true; }
      });
      if (wasAdded) {
        mdmCards.forEach(function(card) {
          if (card.dataset.family !== target || card.dataset.available === 'false') return;
          if (added.some(function(a) { return a.pid === card.dataset.pid; })) return;
          added.push(itemFromCard(card));
          changed = true;
        });
      }
      if (changed) saveState();
    }

    function render() {
      syncMdmToDevice();
      const targetSlotCount = Math.max(MIN, added.length);
      while (list.children.length < targetSlotCount) {
        list.appendChild(list.firstElementChild.cloneNode(true));
      }
      while (list.children.length > targetSlotCount) {
        list.lastElementChild.remove();
      }
      if (CENTER) syncQuantities();

      const slots = list.children;
      for (let i = 0; i < slots.length; i++) {
        const item = added[i];
        const label = slots[i].querySelector('.bundle__summary-slot-label') || slots[i].firstElementChild;
        const removeBtn = slots[i].querySelector('[data-slot-remove]');
        if (item) {
          slots[i].classList.add('is-filled');
          const q = itemQty(item);
          label.textContent = item.title + (q > 1 ? ' ×' + q : '');
          if (removeBtn) {
            removeBtn.hidden = item.required === true;
            removeBtn.dataset.slotIndex = i;
          }
        } else {
          slots[i].classList.remove('is-filled');
          label.textContent = SLOT_LABEL + ' ' + (i + 1);
          if (removeBtn) removeBtn.hidden = true;
        }
      }

      const total = added.reduce(function(sum, item) { return sum + item.price * itemQty(item); }, 0);
      if (totalEl) totalEl.textContent = money(total);

      bar.style.width = Math.min(100, (added.length / MIN) * 100) + '%';

      // Sync is-added class + aria-label on all cards to match `added`
      const pickedDevice = CENTER ? added.find(function(a){ return a.role === 'device'; }) : null;
      products.forEach(function(p) {
        const isIn = added.some(function(a){ return a.pid === p.dataset.pid; });
        const isRequired = p.dataset.required === 'true';
        p.classList.toggle('is-added', isIn);
        const addBtn = p.querySelector('[data-add]');

        // Center-setup locks: non-picked devices grey out while a device is
        // chosen; a single-per-order install already in the cart stays locked.
        let locked = false;
        if (CENTER) {
          if (p.dataset.role === 'device' && pickedDevice && pickedDevice.pid !== p.dataset.pid) locked = true;
          if (p.dataset.role === 'install' && p.dataset.inCart === 'true') locked = true;
          if (p.dataset.role === 'warranty' && !warrantyAllowed()) locked = true;
        }
        p.classList.toggle('is-locked', locked);
        const unavailable = p.dataset.available === 'false';
        if (addBtn && !isRequired && p.dataset.available !== 'false') {
          addBtn.disabled = locked;
          if (locked) addBtn.setAttribute('aria-disabled', 'true');
          else addBtn.removeAttribute('aria-disabled');
        }
        if (addBtn) {
          let aria = isRequired ? 'Included with bundle' : (unavailable ? 'Sold out' : (isIn ? 'Remove item' : 'Add item'));
          if (locked) {
            if (p.dataset.role === 'install') aria = 'Already in your order';
            else if (p.dataset.role === 'warranty') aria = pickedDevice ? 'Not available for the selected device' : 'Select a tablet to add coverage';
            else aria = 'Remove the selected device first';
          }
          addBtn.setAttribute('aria-label', aria + (p.dataset.title ? ' — ' + p.dataset.title : ''));
          addBtn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
          const addLabel = addBtn.querySelector('.bundle__add-label');
          if (addLabel) addLabel.textContent = unavailable ? 'Sold Out' : (isIn ? 'Remove Item' : 'Add Item');
        }
      });

      if (added.length >= MIN) {
        btn.disabled = false;
        setButtonLabel(READY_LABEL);
      } else {
        btn.disabled = true;
        setButtonLabel(SELECT_LABEL + ' (' + (MIN - added.length) + ' remaining)');
      }
    }

    function addProduct(card) {
      if (!card) return;
      const pid = card.dataset.pid;
      if (added.some(function(a){ return a.pid === pid; })) return;
      if (CENTER && card.classList.contains('is-locked')) return;
      const item = itemFromCard(card);
      added.push(item);
      if (item.role === 'device') syncWarrantyToDevice(true);
      saveState();
      render();
    }

    function removeByPid(pid) {
      const idx = added.findIndex(function(a){ return a.pid === pid; });
      if (idx < 0) return;
      if (added[idx].required) return;
      const removed = added[idx];
      added.splice(idx, 1);
      if (removed.role === 'device') syncWarrantyToDevice(false);
      saveState();
      render();
    }

    // Hydrate from localStorage — match saved pids against rendered cards so
    // stale entries (removed/unavailable products) are dropped automatically.
    (function hydrate() {
      const saved = loadState();
      saved.forEach(function(entry) {
        const card = findCard(entry.pid);
        if (!card) return;
        if (entry.variantId) {
          card.dataset.variantId = entry.variantId;
          card.dataset.price = String(entry.price || 0);
          card.dataset.title = entry.title || card.dataset.title;
        }
        if (!added.some(function(a){ return a.pid === entry.pid; })) {
          added.push(itemFromCard(card));
        }
      });
      // Saved warranty entries only survive when the saved device still allows them.
      syncWarrantyToDevice(false);
      saveState(); // Re-persist the cleaned state
    })();

    /* The .pc__quick-add inside each card holds the live variant selection
       (updated by inline color/size pickers). When data-add is clicked we
       prefer that variant over the wrapper's default. */
    function readPickedVariant(p) {
      const qa = p.querySelector('.pc__quick-add[data-variant-id]');
      if (!qa) return null;
      const id = qa.dataset.variantId && parseInt(qa.dataset.variantId, 10);
      if (!id) return null;
      return {
        variantId: String(id),
        price: parseInt(qa.dataset.price, 10) || parseInt(p.dataset.price, 10) || 0,
        title: qa.dataset.productTitle || p.dataset.title || '',
      };
    }

    /* A color-only accessory is not a second configuration decision. Match it
       to the kiosk color selected in the PDP; kiosks without a color option use
       Black as the safe default for the store's Black/White accessories. */
    function normalizeColor(value) {
      const normalized = String(value || '').trim().toLowerCase();
      if (normalized.includes('black')) return 'black';
      if (normalized.includes('white')) return 'white';
      return normalized;
    }

    function pageProductForm() {
      const nearestForm = rootEl.closest('form');
      if (nearestForm) return nearestForm;
      const pageMain = rootEl.closest('main') || document;
      return pageMain.querySelector('.prd__form');
    }

    function selectedKioskColor() {
      const productForm = pageProductForm();
      const selectedPdpColor = productForm && Array.from(
        productForm.querySelectorAll('.pdp-variant-picker [data-option-input]:checked')
      ).find(function(input) { return /colou?r/i.test(input.name || ''); });
      if (selectedPdpColor && selectedPdpColor.value) return selectedPdpColor.value;

      const selectedCoreColor = rootEl.querySelector(
        '.bundle__product[data-role="core"] [data-picker-val].is-selected'
      );
      return selectedCoreColor ? selectedCoreColor.dataset.pickerVal : 'Black';
    }

    function syncCardVariantFromPicker(card) {
      const picked = readPickedVariant(card);
      if (!picked) return false;
      const previousVariant = card.dataset.variantId;
      card.dataset.variantId = picked.variantId;
      card.dataset.price = String(picked.price);
      if (picked.title) card.dataset.title = picked.title;

      const item = added.find(function(entry) { return entry.pid === card.dataset.pid; });
      if (item) {
        item.variantId = picked.variantId;
        item.price = picked.price;
        if (picked.title) item.title = picked.title;
      }
      return previousVariant !== picked.variantId;
    }

    function selectCardColor(card, preferredColor) {
      if (!card) return false;
      const buttons = Array.from(card.querySelectorAll('[data-picker-val][data-variant-id]'));
      if (buttons.length === 0) return false;
      const preferred = normalizeColor(preferredColor);
      const available = buttons.filter(function(button) { return button.dataset.available === 'true'; });
      const candidates = available.length > 0 ? available : buttons;
      let target = candidates.find(function(button) {
        return normalizeColor(button.dataset.pickerVal) === preferred;
      });
      if (!target) {
        target = candidates.find(function(button) {
          return normalizeColor(button.dataset.pickerVal) === 'black';
        }) || candidates[0];
      }
      if (!target) return false;
      buttons.forEach(function(button) {
        button.classList.toggle('is-selected', button === target);
      });
      const pickerButton = card.querySelector('.pc__quick-add[data-variant-id]');
      if (pickerButton) {
        pickerButton.dataset.variantId = target.dataset.variantId || '';
        if (target.dataset.price) pickerButton.dataset.price = target.dataset.price;
        pickerButton.disabled = target.dataset.available !== 'true' || !target.dataset.variantId;
      }
      return syncCardVariantFromPicker(card);
    }

    function syncColorLinkedCards() {
      const preferredColor = selectedKioskColor();
      let changed = false;
      const coreCard = rootEl.querySelector('.bundle__product[data-role="core"]');
      if (coreCard) changed = selectCardColor(coreCard, preferredColor) || changed;
      rootEl.querySelectorAll('.bundle__product[data-color-linked="true"]').forEach(function(card) {
        changed = selectCardColor(card, preferredColor) || changed;
      });
      if (changed) saveState();
      render();
    }

    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
      clearTimeout(showErr._t);
      showErr._t = setTimeout(function() { errEl.hidden = true; errEl.textContent = ''; }, 3500);
    }

    // Add / toggle off from the wrapper's + → × button
    products.forEach(function(p) {
      const addBtn = p.querySelector('[data-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (p.dataset.required === 'true') return;
        const pid = p.dataset.pid;
        if (added.some(function(a){ return a.pid === pid; })) {
          removeByPid(pid);
          return;
        }
        /* Block sold-out products outright. */
        if (p.dataset.available === 'false') {
          showErr('"' + (p.dataset.title || 'Product') + '" is sold out.');
          return;
        }
        /* The overlay control always adds the selected/default variant. Product
           preview is intentionally reserved for the explicit preview button. */
        /* For inline pickers (size or color), the card's quick-add becomes
           disabled when the picked variant is sold out. Refuse to add. */
        const qa = p.querySelector('.pc__quick-add');
        if (qa && qa.disabled && qa.dataset.quickView !== '1') {
          showErr('Selected option is sold out — pick another.');
          return;
        }
        const picked = readPickedVariant(p);
        if (picked) {
          p.dataset.variantId = picked.variantId;
          p.dataset.price = String(picked.price);
          if (picked.title) p.dataset.title = picked.title;
        }
        addProduct(p);
      });
    });

    const productForm = pageProductForm();
    if (productForm) {
      productForm.addEventListener('change', function(e) {
        if (!e.target.matches('.pdp-variant-picker [data-option-input]')) return;
        setTimeout(syncColorLinkedCards, 0);
      });
    }
    rootEl.addEventListener('click', function(e) {
      const coreColor = e.target.closest('.bundle__product[data-role="core"] [data-picker-val]');
      if (coreColor) setTimeout(syncColorLinkedCards, 0);
    });

    /* Listen for variant adds dispatched by the card's "Add to bundle" button
       or the preview modal in bundle mode. detail = { variantId, productId,
       productHandle, title, price, sourceCard }. */
    /* Events are dispatched on `document` from product-card-js / preview-modal,
       so listen there. Gate each event to a wrapper that lives inside this
       bundle instance — multiple bundles on a page each handle their own. */
    document.addEventListener('bundle:add-variant', function(e) {
      const d = e.detail || {};
      if (!d.variantId) return;
      let wrapper = null;
      if (d.targetPid) {
        wrapper = rootEl.querySelector('.bundle__product[data-pid="' + d.targetPid + '"]');
      }
      if (!wrapper && d.sourceCard && rootEl.contains(d.sourceCard)) {
        wrapper = d.sourceCard.closest('.bundle__product');
      }
      if (!wrapper && d.productId) {
        wrapper = rootEl.querySelector('.bundle__product[data-product-id="' + d.productId + '"]');
      }
      if (!wrapper && d.productHandle) {
        wrapper = rootEl.querySelector('.bundle__product[data-product-handle="' + d.productHandle + '"]');
      }
      if (!wrapper) return;
      const existingItem = added.find(function(a){ return a.pid === wrapper.dataset.pid; });
      if (existingItem) {
        if (existingItem.required) {
          existingItem.variantId = String(d.variantId);
          existingItem.price = parseInt(d.price, 10) || existingItem.price;
          existingItem.title = d.title || existingItem.title;
          wrapper.dataset.variantId = existingItem.variantId;
          wrapper.dataset.price = String(existingItem.price);
          wrapper.dataset.title = existingItem.title;
          render();
        }
        return;
      }
      wrapper.dataset.variantId = String(d.variantId);
      wrapper.dataset.price = String(d.price || 0);
      wrapper.dataset.title = d.title || wrapper.dataset.title;
      addProduct(wrapper);
    });

    // Remove from summary slot
    list.addEventListener('click', function(e) {
      const rm = e.target.closest('[data-slot-remove]');
      if (!rm) return;
      const i = parseInt(rm.dataset.slotIndex, 10);
      if (Number.isFinite(i) && added[i]) removeByPid(added[i].pid);
    });

    // Center-setup: core quantity stepper drives every synced quantity.
    const coreQtyInput = rootEl.querySelector('[data-core-qty-input]');
    if (CENTER && coreQtyInput) {
      rootEl.addEventListener('click', function(e) {
        const step = e.target.closest('[data-core-step]');
        if (!step) return;
        e.preventDefault();
        coreQty = Math.max(1, (parseInt(coreQtyInput.value, 10) || 1) + parseInt(step.dataset.coreStep, 10));
        coreQtyInput.value = String(coreQty);
        render();
      });
      coreQtyInput.addEventListener('change', function() {
        coreQty = Math.max(1, parseInt(coreQtyInput.value, 10) || 1);
        coreQtyInput.value = String(coreQty);
        render();
      });
    }

    // Center-setup: keep the install lock honest as the cart changes.
    if (CENTER) {
      document.addEventListener('cart:updated', function(e) {
        const cart = e.detail && e.detail.cart;
        if (!cart || !cart.items) return;
        const ids = {};
        cart.items.forEach(function(it) { ids[String(it.product_id)] = true; });
        let changed = false;
        products.forEach(function(p) {
          if (p.dataset.role !== 'install') return;
          const inCart = ids[String(p.dataset.productId)] ? 'true' : 'false';
          if (p.dataset.inCart !== inCart) { p.dataset.inCart = inCart; changed = true; }
          if (inCart === 'true') {
            const idx = added.findIndex(function(a) { return a.pid === p.dataset.pid; });
            if (idx >= 0 && !added[idx].required) { added.splice(idx, 1); changed = true; }
          }
        });
        if (changed) { saveState(); render(); }
      });
    }

    // Add every selected variant together and retain package metadata so the
    // cart can present the lines as one group.
    btn.addEventListener('click', function() {
      if (added.length < MIN) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      const bundleInstance = bundleInstanceId();
      if (CENTER) syncQuantities();
      const items = added
        .filter(function(a) { return a.variantId && !String(a.variantId).startsWith('demo-'); })
        .map(function(a) {
          const props = TAG
            ? { _bundle: '1', _bundle_tag: TAG, _bundle_instance: bundleInstance }
            : { _bundle: '1', _bundle_instance: bundleInstance };
          const bundleTitle = rootEl.dataset.bundleTitle;
          if (bundleTitle) props._bundle_title = bundleTitle;
          if (CENTER && a.role === 'install') props._single_order_addon = '1';
          return {
            id: parseInt(a.variantId, 10),
            quantity: itemQty(a),
            properties: props
          };
        });

      if (items.length === 0) {
        if (errEl) {
          errEl.textContent = 'Select at least one available product.';
          errEl.hidden = false;
        }
        return;
      }

      btn.disabled = true;
      setButtonLabel(ADDING_LABEL);

      const request = window.cartStore
        ? window.cartStore.add({ items: items, openDrawer: true })
        : fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function(r) {
            if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Add failed'); });
            window.location.assign('/cart');
          });
      request
        .then(function() {
          resetBuilder();
        })
        .catch(function(e) {
          btn.disabled = false;
          setButtonLabel(READY_LABEL);
          if (errEl) {
            errEl.textContent = e.message || "Couldn't add bundle.";
            errEl.hidden = false;
          }
        });
    });

    syncColorLinkedCards();

    /* The header (nav + search bar) is sticky, so a plain block:'start' scroll
       parks the builder underneath it. scrollIntoView honors scroll-margin-top;
       measure the live header height each time since it changes per breakpoint. */
    function syncJumpOffset() {
      var header = document.querySelector('.site-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
      rootEl.style.scrollMarginTop = offset + 'px';
    }

    /* Quick-view "Build your bundle" links land on /products/<handle>#bundle —
       bring the builder into view once it has rendered. */
    if (window.location.hash === '#bundle') {
      requestAnimationFrame(function() {
        syncJumpOffset();
        rootEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Only reveal "#bundle" jump links once we know this builder actually
       rendered — products with no bundle set keep the [hidden] attribute. */
    if (!rootEl.hasAttribute('hidden')) {
      document.documentElement.classList.add('bundle-jump-ok');
    }

    /* Same-page jump links (the buy-area "Build your Kiosk" button). The theme
       sets no global scroll-behavior, so a bare href="#bundle" would hard-jump;
       take the click over and animate it instead. Bound once per builder. */
    if (!rootEl.dataset.jumpBound) {
      rootEl.dataset.jumpBound = '1';
      document.addEventListener('click', function(ev) {
        var link = ev.target.closest && ev.target.closest('a[href$="#bundle"]');
        if (!link) return;
        // only hijack links that point at this page, not cross-product links
        if (link.pathname && link.pathname !== window.location.pathname) return;
        ev.preventDefault();
        syncJumpOffset();
        rootEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && history.replaceState) {
          history.replaceState(null, '', '#bundle');
        }
      });
    }
  }

  function bootBundle() {
    document.querySelectorAll('.bundle-block').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBundle);
  } else {
    bootBundle();
  }
  document.addEventListener('shopify:section:load', bootBundle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shop-the-feed"] && !Shopify.designMode) return;
  try {
    function initFeedSection(section) {
    if (!section || section.dataset.bound) return;
    section.dataset.bound = '1';

    const modal = section.parentElement.querySelector('[data-look-modal]') || document.querySelector('[data-look-modal]');
    if (!modal) return;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    const tiles = Array.from(section.querySelectorAll('[data-tile]'));
    const tileData = tiles.map((t) => {
      try { return JSON.parse(t.querySelector('[data-tile-data]').textContent); }
      catch (e) { return null; }
    });

    const imgEl = modal.querySelector('[data-look-img]');
    // JS assigns src below — keep the intrinsic width/height attributes honest.
    if (imgEl) imgEl.addEventListener('load', () => {
      if (imgEl.naturalWidth) { imgEl.width = imgEl.naturalWidth; imgEl.height = imgEl.naturalHeight; }
    });
    const hotspotsEl = modal.querySelector('[data-look-hotspots]');
    const productsEl = modal.querySelector('[data-look-products]');
    const captionEl = modal.querySelector('[data-look-caption]');
    const prevBtn = modal.querySelector('[data-look-prev]');
    const nextBtn = modal.querySelector('[data-look-next]');
    const closers = modal.querySelectorAll('[data-look-close]');
    let currentIdx = 0;

    function openModal(i) {
      currentIdx = i;
      render(i);
      modal.hidden = false;
      modal.inert = false;
      document.body.classList.add('feed-look-open');
    }
    function closeModal() {
      if (modal.contains(document.activeElement)) document.activeElement.blur();
      modal.inert = true;
      modal.hidden = true;
      document.body.classList.remove('feed-look-open');
    }
    function render(i) {
      const data = tileData[i];
      if (!data) return;
      const imageWrap = modal.querySelector('[data-look-image]');
      if (data.image) {
        imgEl.src = data.image;
        imgEl.style.display = '';
        if (imageWrap) imageWrap.classList.remove('is-empty');
      } else {
        imgEl.removeAttribute('src');
        imgEl.style.display = 'none';
        if (imageWrap) imageWrap.classList.add('is-empty');
      }
      imgEl.alt = data.image_alt || '';
      captionEl.textContent = data.caption || '';
      renderHotspots(data.products || []);
      renderProducts(data.products || []);
      const countEl = modal.querySelector('[data-look-count]');
      if (countEl) countEl.textContent = (i + 1) + ' / ' + tileData.length;
      prevBtn.disabled = tileData.length <= 1;
      nextBtn.disabled = tileData.length <= 1;
    }

    function renderHotspots(products) {
      hotspotsEl.innerHTML = '';
      products.forEach((p, idx) => {
        const hs = p.hotspot || [50, 50];
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'feed-look__hotspot';
        btn.style.left = hs[0] + '%';
        btn.style.top = hs[1] + '%';
        btn.dataset.productIdx = idx;
        btn.setAttribute('aria-label', 'View ' + p.title);
        btn.addEventListener('mouseenter', () => highlightProduct(idx, true));
        btn.addEventListener('mouseleave', () => highlightProduct(idx, false));
        btn.addEventListener('click', () => {
          const row = productsEl.querySelector(`[data-product-idx="${idx}"]`);
          if (row) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          highlightProduct(idx, true);
          setTimeout(() => highlightProduct(idx, false), 1200);
        });
        hotspotsEl.appendChild(btn);
      });
    }

    function highlightProduct(idx, on) {
      const row = productsEl.querySelector(`[data-product-idx="${idx}"]`);
      if (row) row.classList.toggle('is-highlight', on);
      const hs = hotspotsEl.querySelector(`[data-product-idx="${idx}"]`);
      if (hs) hs.classList.toggle('is-active', on);
    }

    function money(value) { return value || ''; }

    function normColor(v) { return (v || '').toLowerCase().replace(/\s+/g, ''); }

    function renderProducts(products) {
      productsEl.innerHTML = '';
      if (!products.length) {
        const empty = document.createElement('div');
        empty.className = 'feed-look__empty';
        empty.innerHTML = '<p>No products tagged on this look yet.</p><p class="feed-look__empty-hint">Edit this section in the theme editor and attach up to 4 products per tile to make them shoppable.</p>';
        productsEl.appendChild(empty);
        return;
      }
      products.forEach((p, idx) => {
        const row = document.createElement('div');
        row.className = 'feed-look__product';
        row.dataset.productIdx = idx;

        const img = document.createElement('a');
        img.href = p.url === '#' ? undefined : p.url;
        img.className = 'feed-look__product-img';
        if (p.url !== '#') { img.target = '_blank'; img.rel = 'noopener'; }
        img.innerHTML = p.image
          ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
          : '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

        const body = document.createElement('div');
        body.className = 'feed-look__product-body';
        let priceHtml = `<span class="feed-look__product-price">${p.price}</span>`;
        if (p.compare_at_price) priceHtml += `<span class="feed-look__product-price-was">${p.compare_at_price}</span>`;
        body.innerHTML = `<a class="feed-look__product-title" href="${p.url}">${p.title}</a><div>${priceHtml}</div>`;

        const action = document.createElement('div');
        action.className = 'feed-look__product-action';

        row.addEventListener('mouseenter', () => {
          const hs = hotspotsEl.querySelector(`[data-product-idx="${idx}"]`);
          if (hs) hs.classList.add('is-active');
        });
        row.addEventListener('mouseleave', () => {
          const hs = hotspotsEl.querySelector(`[data-product-idx="${idx}"]`);
          if (hs) hs.classList.remove('is-active');
        });

        const hasColor = p.color_option_index >= 0 && p.options && p.options[p.color_option_index];
        const qa = document.createElement('button');
        qa.type = 'button';
        qa.className = 'feed-look__qa';

        row.appendChild(img);
        row.appendChild(body);
        row.appendChild(action);

        if (!p.available) {
          qa.textContent = 'Sold out';
          qa.disabled = true;
          qa.classList.add('feed-look__qa--sold');
          action.appendChild(qa);
        } else if (p.has_only_default_variant || !hasColor) {
          qa.textContent = 'Add';
          qa.addEventListener('click', () => addToCart(qa, p.default_variant_id));
          action.appendChild(qa);
        } else {
          qa.textContent = 'Add';
          qa.disabled = true;
          action.appendChild(qa);

          const colors = document.createElement('div');
          colors.className = 'feed-look__colors';
          let selected = null;
          p.options[p.color_option_index].values.forEach((val) => {
            const label = document.createElement('label');
            label.className = 'feed-look__color';
            label.title = val;
            label.style.setProperty('--swatch', normColor(val));
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = `feed-color-${idx}-${currentIdx}`;
            radio.value = val;
            const dot = document.createElement('span');
            dot.className = 'feed-look__color-dot';
            label.appendChild(radio);
            label.appendChild(dot);

            const matchingVariants = p.variants.filter((v) => v.options[p.color_option_index] === val);
            const anyAvailable = matchingVariants.some((v) => v.available);
            if (!anyAvailable) label.classList.add('is-sold-out');

            radio.addEventListener('change', () => {
              if (!anyAvailable) return;
              const first = matchingVariants.find((v) => v.available) || matchingVariants[0];
              selected = first;
              qa.disabled = !first.available;
              qa.textContent = first.available ? 'Add' : 'Sold out';
            });
            colors.appendChild(label);
          });
          row.appendChild(colors);

          qa.addEventListener('click', () => {
            if (!selected) return;
            addToCart(qa, selected.id);
          });
        }

        productsEl.appendChild(row);
      });
    }

    async function addToCart(btn, variantId) {
      if (!variantId) return;
      if (variantId < 0) {
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
        return;
      }
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        if (window.cartStore) {
          await window.cartStore.add({ items: [{ id: variantId, quantity: 1 }], openDrawer: true });
        } else {
          const fd = new FormData();
          fd.append('id', variantId);
          fd.append('quantity', '1');
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('add failed');
          window.location.assign('/cart');
          return;
        }
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
      } catch (e) {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
      }
    }

    tiles.forEach((tile, idx) => {
      tile.querySelectorAll('[data-open-look]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openModal(idx);
        });
      });
    });

    closers.forEach((c) => c.addEventListener('click', closeModal));
    prevBtn.addEventListener('click', () => { currentIdx = (currentIdx - 1 + tileData.length) % tileData.length; render(currentIdx); });
    nextBtn.addEventListener('click', () => { currentIdx = (currentIdx + 1) % tileData.length; render(currentIdx); });
    document.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowLeft') prevBtn.click();
      else if (e.key === 'ArrowRight') nextBtn.click();
    });

    /* Carousel slider (mirrors hero slideshow's pointer-drag pattern, works on touch + desktop) */
    const track = section.querySelector('[data-track]');
    const cards = Array.from(track.querySelectorAll('.feed__tile'));
    const slidePrev = section.querySelector('.feed__nav[data-dir="prev"]');
    const slideNext = section.querySelector('.feed__nav[data-dir="next"]');
    const paginationHost = section.querySelector('[data-carousel-pagination]');
    if (track) track.addEventListener('dragstart', (e) => e.preventDefault());
    if (track && cards.length) {
      let pos = 0;
      let pointerActive = false;
      let isDragging = false;
      let pointerId = null;
      let dragStartX = 0;
      let dragStartY = 0;
      let dragDX = 0;
      let baseOffset = 0;
      let suppressClick = false;
      let paginationButtons = [];
      const DRAG_THRESHOLD = 6;

      const paddingLeft = () => parseFloat(getComputedStyle(track.parentElement).paddingLeft) || 0;
      const rightBreath = () => paddingLeft() * 2;
      const maxScroll = () => {
        const last = cards[cards.length - 1];
        const trackEnd = last.offsetLeft + last.offsetWidth;
        const viewportW = track.parentElement.clientWidth;
        // Translate needed so the last card's right edge lands at
        // viewport right minus `breath`.
        return Math.max(0, paddingLeft() + trackEnd - viewportW + rightBreath());
      };
      const maxIndex = () => {
        const max = maxScroll();
        const firstOffset = cards[0].offsetLeft;
        for (let i = 0; i < cards.length; i++) {
          if ((cards[i].offsetLeft - firstOffset) >= max - 1) return i;
        }
        return cards.length - 1;
      };
      const clamp = (n) => Math.max(0, Math.min(maxIndex(), n));
      const targetOffset = () => {
        const target = cards[pos];
        if (!target) return 0;
        const firstOffset = cards[0].offsetLeft;
        return Math.min(target.offsetLeft - firstOffset, maxScroll());
      };
      const updateNav = () => {
        if (slidePrev) slidePrev.disabled = pos <= 0;
        if (slideNext) slideNext.disabled = pos >= maxIndex();
        paginationButtons.forEach((button, index) => {
          const active = index === pos;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      const setTransform = (animate) => {
        track.style.transition = animate === false ? 'none' : '';
        track.style.transform = 'translateX(' + (-targetOffset()) + 'px)';
        updateNav();
      };
      const go = (dir) => { pos = clamp(pos + dir); setTransform(true); };
      slidePrev && slidePrev.addEventListener('click', () => go(-1));
      slideNext && slideNext.addEventListener('click', () => go(1));
      const buildPagination = () => {
        if (!paginationHost) return;
        paginationHost.replaceChildren();
        paginationButtons = [];
        for (let index = 0; index <= maxIndex(); index++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'carousel-pagination__item';
          button.setAttribute('aria-label', 'Go to item ' + (index + 1));
          button.addEventListener('click', () => {
            pos = clamp(index);
            setTransform(true);
          });
          paginationHost.appendChild(button);
          paginationButtons.push(button);
        }
        updateNav();
      };

      /* Drag detection only kicks in once movement exceeds the threshold AND is
         primarily horizontal. Plain taps/clicks never enter drag mode, so anchor
         and button navigation works without any pointer-events interference. */
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('[data-dir]')) return;
        pointerActive = true;
        isDragging = false;
        pointerId = e.pointerId;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragDX = 0;
        baseOffset = cards[pos].offsetLeft;
      });
      track.addEventListener('pointermove', (e) => {
        if (!pointerActive) return;
        const dx = e.clientX - dragStartX;
        const dy = e.clientY - dragStartY;
        if (!isDragging) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            // Vertical scroll wins — abandon this gesture entirely.
            pointerActive = false;
            return;
          }
          isDragging = true;
          track.classList.add('is-dragging');
          track.style.transition = 'none';
          try { track.setPointerCapture(pointerId); } catch (_) {}
        }
        dragDX = dx;
        const proposed = baseOffset - dragDX;
        const max = maxScroll();
        let clamped;
        if (proposed < 0) clamped = proposed * 0.35;
        else if (proposed > max) clamped = max + (proposed - max) * 0.35;
        else clamped = proposed;
        track.style.transform = 'translateX(' + (-clamped) + 'px)';
      });
      const endDrag = () => {
        if (!pointerActive) return;
        pointerActive = false;
        if (!isDragging) return; // plain click — let it through
        isDragging = false;
        track.classList.remove('is-dragging');
        track.style.transition = '';
        suppressClick = true;
        const threshold = cards[pos].offsetWidth * 0.15;
        if (dragDX < -threshold) go(1);
        else if (dragDX > threshold) go(-1);
        else setTransform(true);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', (e) => e.preventDefault());
      /* Swallow only the synthetic click that follows a real swipe */
      track.addEventListener('click', (e) => {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
          suppressClick = false;
        }
      }, true);

      let resizeRaf;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => {
          pos = clamp(pos);
          buildPagination();
          setTransform(false);
        });
      });
      buildPagination();
      setTransform(false);
    }
  }

  function bootFeed() {
    document.querySelectorAll('[data-feed-carousel]').forEach(initFeedSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFeed);
  } else {
    bootFeed();
  }
  document.addEventListener('shopify:section:load', bootFeed);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shop-the-look"] && !Shopify.designMode) return;
  try {
    function initStl(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const withSlider = root.classList.contains('stl--with-slider');
    const hotspots = Array.from(root.querySelectorAll('[data-hotspot]'));

    if (!withSlider) {
      hotspots.forEach((hs) => {
        const btn = hs.querySelector('[data-open]');
        if (!btn) return;
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const wasOpen = hs.classList.contains('is-open');
          hotspots.forEach((h) => h.classList.remove('is-open'));
          if (!wasOpen) hs.classList.add('is-open');
        });
      });
      document.addEventListener('click', () => {
        hotspots.forEach((h) => h.classList.remove('is-open'));
      });
      return;
    }

    /* Slider mode — populate rail from each hotspot's <template>, then wire hover/scroll */
    const list = root.querySelector('[data-stl-list]');
    const empty = root.querySelector('[data-stl-empty]');
    const viewport = root.querySelector('.stl__rail-viewport');
    const prevBtn = root.querySelector('[data-rail-dir="prev"]');
    const nextBtn = root.querySelector('[data-rail-dir="next"]');

    if (list) {
      hotspots.forEach((hs, index) => {
        const tmpl = hs.querySelector('[data-rail-template]');
        if (!tmpl || !tmpl.content || !tmpl.content.firstElementChild) return;
        const clone = tmpl.content.firstElementChild.cloneNode(true);
        window.NerdioClone?.uniqueIds(clone, root.id + '-rail-' + index);
        list.appendChild(clone);
      });
    }

    const items = list ? Array.from(list.querySelectorAll('.stl__rail-item')) : [];
    if (empty) empty.hidden = items.length > 0;
    let pos = 0;

    const itemHeight = () => items.length ? items[0].offsetHeight + 12 : 0;
    const maxPos = () => {
      if (!viewport || !list) return 0;
      return Math.max(0, items.length - Math.floor(viewport.clientHeight / itemHeight()));
    };
    const updateNav = () => {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = pos <= 0;
      nextBtn.disabled = pos >= maxPos();
    };
    const setTransform = () => {
      if (!list) return;
      list.style.transform = 'translateY(' + (-pos * itemHeight()) + 'px)';
      updateNav();
    };
    const goTo = (n) => { pos = Math.max(0, Math.min(maxPos(), n)); setTransform(); };

    prevBtn && prevBtn.addEventListener('click', () => goTo(pos - 1));
    nextBtn && nextBtn.addEventListener('click', () => goTo(pos + 1));

    const findItem = (handle) => items.find((it) => it.dataset.handle === handle);
    const findHotspot = (handle) => hotspots.find((h) => h.dataset.handle === handle);

    const highlight = (handle, on) => {
      const item = findItem(handle);
      const hs = findHotspot(handle);
      if (item) item.classList.toggle('is-highlight', on);
      if (hs) hs.classList.toggle('is-active', on);
      if (on && item) {
        const idx = items.indexOf(item);
        const max = maxPos();
        if (idx < pos) goTo(idx);
        else if (idx >= pos + Math.floor(viewport.clientHeight / itemHeight())) goTo(Math.min(max, idx));
      }
    };

    hotspots.forEach((hs) => {
      const handle = hs.dataset.handle;
      if (!handle) return;
      const trigger = hs.querySelector('[data-open]') || hs;
      hs.addEventListener('mouseenter', () => highlight(handle, true));
      hs.addEventListener('mouseleave', () => highlight(handle, false));
      trigger.addEventListener('focus', () => highlight(handle, true));
      trigger.addEventListener('blur', () => highlight(handle, false));
    });

    items.forEach((item) => {
      const handle = item.dataset.handle;
      if (!handle) return;
      item.addEventListener('mouseenter', () => highlight(handle, true));
      item.addEventListener('mouseleave', () => highlight(handle, false));
    });

    let resizeRaf;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => { goTo(Math.min(pos, maxPos())); });
    });
    setTransform();
  }

  function bootStl() {
    document.querySelectorAll('.stl-block[data-stl]').forEach(initStl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStl);
  } else {
    bootStl();
  }
  document.addEventListener('shopify:section:load', bootStl);
  document.addEventListener('shopify:block:load', bootStl);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-embed"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.veInit) return;
    root.dataset.veInit = '1';

    var provider = root.dataset.provider;
    var trigger = root.querySelector('.video-embed__trigger');
    var frame = root.querySelector('.video-embed__frame');
    if (!frame) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function buildSrc(autoplay) {
      var base = root.dataset.embedBase;
      var id = root.dataset.videoId;
      var loop = root.dataset.loop === 'true';
      var controls = root.dataset.controls === 'true';
      var params = [];
      if (provider === 'youtube') {
        if (autoplay) { params.push('autoplay=1'); params.push('mute=1'); }
        params.push('rel=0'); params.push('modestbranding=1'); params.push('playsinline=1');
        if (!controls) params.push('controls=0');
        if (loop) { params.push('loop=1'); params.push('playlist=' + id); }
      } else if (provider === 'vimeo') {
        if (autoplay) { params.push('autoplay=1'); params.push('muted=1'); }
        params.push('playsinline=1');
        if (!controls) params.push('controls=0');
        if (loop) params.push('loop=1');
      }
      return base + (params.length ? '?' + params.join('&') : '');
    }

    function injectIframe(autoplay) {
      if (root.dataset.vePlaying || !root.dataset.embedBase) return;
      root.dataset.vePlaying = '1';
      var wantAutoplay = autoplay && !reduce;
      var iframe = document.createElement('iframe');
      iframe.src = buildSrc(wantAutoplay);
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.title = root.dataset.videoTitle || 'Video player';
      iframe.className = 'video-embed__iframe';
      frame.appendChild(iframe);
      if (trigger) trigger.style.display = 'none';
      root.classList.add('video-embed--playing');
    }

    function playFile() {
      var v = root.querySelector('.video-embed__video');
      if (!v) return;
      v.setAttribute('controls', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      if (trigger) trigger.style.display = 'none';
      root.classList.add('video-embed--playing');
    }

    function start(userInitiated) {
      if (provider === 'mp4') playFile();
      else injectIframe(userInitiated || root.dataset.autoplay === 'true');
    }

    if (trigger) {
      trigger.addEventListener('click', function () { start(true); });
    }

    // Not lazy: load immediately. Autoplay only when requested (and allowed).
    if (root.dataset.eager === 'true' && provider !== 'mp4') {
      injectIframe(root.dataset.autoplay === 'true');
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.video-embed[data-provider]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
